/**
 * SalesHistoryBotica.jsx
 * ─────────────────────────────────────────────────────────────────────────────
 * Wrapper de SalesHistory para BOTICA / FARMACIA.
 * Pasa tipoNegocio="botica" para que SalesHistory pueda mostrar columnas
 * extra como: lotes involucrados, tipo de comprobante (Boleta/Factura).
 * ─────────────────────────────────────────────────────────────────────────────
 */
import React from 'react';
import SalesHistory from './SalesHistory';

const SalesHistoryBotica = ({ sales, onRefresh }) => {
    return (
        <SalesHistory
            sales={sales}
            onRefresh={onRefresh}
            tipoNegocio="botica"
        />
    );
};

export default SalesHistoryBotica;
